var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.dbConfig.whatsapp),expression:"dbConfig.whatsapp"}],staticClass:"whatsapp-button",attrs:{"href":'https://wa.me/' + _vm.dbConfig.whatsapp,"aria-label":"WhatsApp"}},[_c('i',{staticClass:"svg-icon whatsapp"})])
}
var staticRenderFns = []

export { render, staticRenderFns }